__turbopack_context__.v({
  "ctaContainer": "Nm3YLG_ctaContainer",
  "deferredCreatorCard": "Nm3YLG_deferredCreatorCard",
  "deferredLicense": "Nm3YLG_deferredLicense",
  "detailLabel": "Nm3YLG_detailLabel",
  "detailRow": "Nm3YLG_detailRow",
  "detailRowPlain": "Nm3YLG_detailRowPlain",
  "detailRowTop": "Nm3YLG_detailRowTop",
  "detailsPanel": "Nm3YLG_detailsPanel",
  "fileRow": "Nm3YLG_fileRow",
  "mainSection": "Nm3YLG_mainSection",
  "sidebarSection": "Nm3YLG_sidebarSection",
});
